import { API_URLS } from "shared/constants";
import { BackendEntityType } from "shared/types";

export const getListMembersEPURL = (entityType: BackendEntityType) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return API_URLS.CLUB.LIST_MEMBERS;
		case BackendEntityType.SoccerTeam:
			return API_URLS.TEAM.LIST_MEMBERS;
		case BackendEntityType.SoccerLeague:
			return API_URLS.LEAGUE.LIST_MEMBERS;
		case BackendEntityType.SoccerFacility:
			return API_URLS.FACILITY.LIST_MEMBERS;
		case BackendEntityType.SoccerReforg:
			return API_URLS.ORGANIZATION.LIST_MEMBERS;
	}
	return "";
};

export const getListMembersParamName = (entityType: BackendEntityType) => {
	switch (entityType) {
		case BackendEntityType.SoccerClub:
			return "clubId";
		case BackendEntityType.SoccerTeam:
			return "teamId";
		case BackendEntityType.SoccerLeague:
			return "leagueId";
		case BackendEntityType.SoccerFacility:
			return "facilityId";
		case BackendEntityType.SoccerReforg:
			return "refereeOrganizationId";
	}
	return "";
};
